import {Component, ElementRef, EventEmitter, Inject, Output, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProgressService} from '../../../service/progress.service';
import {NotificationHandler} from '../../../helper/notification.handler';
import {BaseModalComponent} from '../base-modal/base-modal.component';

export interface ConfirmationData {
  title?: string;
  content?: string;
  details?: string;
  action?: string;
  cancel_action?: string;
  item?: any;
}

export interface ConfirmationContext {
  data: any;
  modal: ConfirmationModalComponent;
}

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent extends BaseModalComponent {

  title: string;
  content: string;
  details?: string;
  action: string;
  cancelAction: string;

  @Output() actionConfirmed = new EventEmitter<ConfirmationContext>();

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  private readonly data: ConfirmationData;

  constructor(dialogRef: MatDialogRef<ConfirmationModalComponent>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: ConfirmationData) {
    super(dialogRef, progressService);

    this.title = data.title || $localize`:Confirm Modal|Confirm modal confirmation title@@confirm-modal-confirmation-title:Confirmation`;
    this.content = data.content || $localize`:Confirm Modal|Confirm modal prompt@@confirm-modal-prompt:Do you want to proceed?`;
    this.details = data.details;
    this.action = data.action || $localize`:General|Proceed action label@@general-proceed-action-label:Proceed`;
    this.cancelAction = data.cancel_action || $localize`:General|Cancel action label@@general-cancel-action-label:Cancel`;

    this.data = data;
  }

  proceed(): void {
    this.startProgress();

    this.actionConfirmed.emit({
      data: this.data,
      modal: this
    });
  }

  proceedAllowed(): boolean {
    return true;
  }

  public proceedHandled(error?: string, details?: unknown) {
    if (error) {
      NotificationHandler.handleError(error, details);
      this.stopProgress();
    } else {
      this.stopProgress();
      this.closeModal();
    }
  }
}
